export class StripeService {

    getToken(pk, card: StripeCardTokenData): any {
        Stripe.setPublishableKey(pk);
        return new Promise((resolve, reject) => {
            Stripe.card.createToken(card, (status, response) => {
                if (response.error) {
                    var error = response.error;
                    if (error.type == "invalid_request_error") {
                        reject({message: "Stripe: " + response.error.message});
                    } else {
                        reject({ stripe: true, error: response.error });
                    }
                }
                else {
                    resolve(response);
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/Apps/ticketing/services/stripe.ts